export default "__VITE_ASSET__BDiCby$C__"